// @ts-nocheck


import React from 'react';
import Input from 'antd/lib/input';

import {
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem } from
'./../../../components';

import Field from './../../../components/card/Field';
import { SectionContent } from '../../../components/hoc/common/components/elements';

import Selects from '../../../components/selects';

const { MaintenanceTypeOfWorkSelect } = Selects;












export const StockPartFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) =>
<SectionContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter,
        showAdditional,
        handleAdditional
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <Input
              placeholder="Название"
              size="small"
              onChange={(e) =>
              changeValue('search', e.target.value || undefined)
              }
              value={values.search} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <MaintenanceTypeOfWorkSelect
              placeholder="Вид работ"
              size="small"
              onChange={(value) => changeValue('workType', value)}
              value={values.workType} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SectionContent>;


export default StockPartFilter;
